"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureName = void 0;
exports.FeatureName = {
    EmailLogin: 'emailLogin',
    PhoneLogin: 'phoneLogin',
    L1Login: 'l1Login',
    EmailResetPassword: 'emailResetPassword',
    PhoneResetPassword: 'phoneResetPassword',
    FacebookLogin: 'facebookLogin',
    LineLogin: 'lineLogin',
    GoogleLogin: 'googleLogin',
    AppleLogin: 'appleLogin',
    Signup: 'signup',
    WeChatLogin: 'weChatLogin',
    KakaoLogin: 'kakaoLogin',
    GoogleAppLogin: 'googleAppLogin',
    WeChatAppLogin: 'weChatAppLogin',
    FacebookAppLogin: 'facebookAppLogin',
    LineAppLogin: 'lineAppLogin',
    KakaoTalkLogin: 'kakaoTalkLogin',
    OtpLogin: 'otpLogin',
    WhatsAppLogin: 'whatsAppLogin',
    Mfa: 'mfa',
    SignInCallBack: 'signInCallBack',
    UseNewPhoneValidation: 'useNewPhoneValidation',
    UserSessionManagement: 'userSessionManagement',
    SignInWithOtp: 'signInWithOtp',
    PasskeyAuthentication: 'passkeyAuthentication',
    WalletEnablePasskey: 'walletEnablePasskey',
};
//# sourceMappingURL=featureName.js.map